// extracted by mini-css-extract-plugin
export default {"cleDemoHistogram":"cleDemoHistogram-Zbj1m"};